type Props = {
  status: string
}

const RouteSenderStatusCell = ({status}: Props) => {
  const badgeColor =
    status.toLowerCase() === 'active' ? 'badge-light-primary' : 'badge-light-danger'

  return <span className={`badge ${badgeColor} fs-7`}>{status}</span>
}

export default RouteSenderStatusCell
